<template>
  <div class="product-list page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="search-input box-item"
            v-model="productName"
            placeholder="产品名称"
            style="width: 100%"
            clearable
          ></el-input>
        </div>
        <el-input
          class="search-input box-item hidden-xs-only product-name-input"
          v-model="productName"
          placeholder="产品名称"
          style="width: 220px"
          clearable
        ></el-input>
        <el-input
          class="search-input box-item product-code-input"
          v-model="productCode"
          placeholder="产品编码"
          style="width: 220px"
          clearable
        ></el-input>
        <el-select
          class="search-input box-item status-input"
          v-model="status"
          placeholder="状态"
          clearable
          @change="searchHandle"
        >
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option>
        </el-select>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('auth:product:save')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('auth:product:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn"
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          class="authorize-product-table"
          multiple
          v-model="selected"
          :data="listData"
        >
          <template slot="thead">
            <vs-th class="id-col">ID</vs-th>
            <vs-th class="product-name-col">产品名称</vs-th>
            <vs-th class="product-code-col">产品编码</vs-th>
            <vs-th>试用期限</vs-th>
            <vs-th class="status-col">状态</vs-th>
            <vs-th class="time-col">创建时间</vs-th>
            <vs-th class="time-col">更新时间</vs-th>
            <vs-th class="action-col">操作</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td class="id-col">{{ tr.id }}</vs-td>
              <vs-td class="product-name-col">{{ tr.productName || '-' }}</vs-td>
              <vs-td class="product-code-col">{{ tr.productCode || '-' }}</vs-td>
              <vs-td>{{ tr.trialPeriod === null || tr.trialPeriod === undefined ? '-' : tr.trialPeriod + '天' }}</vs-td>
              <vs-td class="status-col">
                <span
                  class="tag-box"
                  :style="getStyle(tr)"
                >{{ getStatus(tr) }}</span>
              </vs-td>
              <vs-td class="time-col">{{ parseTime(tr.createTime) }}</vs-td>
              <vs-td class="time-col">{{ parseTime(tr.updateTime) }}</vs-td>
              <vs-td class="action-col">
                <el-button
                  type="text"
                  v-if="isAuth('auth:product:update')"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('auth:product:delete')"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{ total }} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-product-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addSuccess"
    ></add-product-dialog>
    <edit-product-dialog
      :form-data="formData"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editSuccess"
    ></edit-product-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import addProductDialog from "@/components/authorize/product/addProductDialog";
import editProductDialog from "@/components/authorize/product/editProductDialog";
import { mapGetters } from 'vuex'
import { colorRgba, parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { deleteProduct } from "@/api/authorize/product";

export default {
  name: "productIndex",
  components: {
    addProductDialog,
    editProductDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      productName: '',
      productCode: '',
      status: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      formData: {},
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor', 'userInfo']),
  },
  created() {
    this.init();
  },
  methods: {
    parseTime,
    beforeInit() {
      this.url = '/wx/manage/authorizedProduct/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order: 'desc'
      }
      if (this.productName) {
        this.params.productName = this.productName;
      }
      if (this.productCode) {
        this.params.productCode = this.productCode;
      }
      if (this.status !== '') {
        this.params.status = this.status;
      }
      return true;
    },
    addHandle() {
      this.addDialogShow = true;
    },
    addSuccess() {
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row) {
      this.formData = row;
      this.editDialogShow = true;
    },
    editSuccess() {
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog() {
      this.editDialogShow = false;
    },
    closeAddDialog() {
      this.addDialogShow = false;
    },
    deleteHandle(row) {
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids) {
      deleteProduct(ids).then(() => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    getStatus(tr) {
      return tr.status === 1 ? '有效' : '无效';
    },
    getStyle(tr) {
      if (tr.status === 0) {
        return {
          backgroundColor: colorRgba(this.red, 0.1),
          color: this.red,
        };
      } else {
        return {
          backgroundColor: colorRgba(this.green, 0.1),
          color: this.green,
        };
      }
    },
    searchHandle() {
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.product-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .authorize-product-table {
    min-width: 900px;
  }
  .id-col {
    min-width: 56px;
    white-space: nowrap;
  }
  .product-name-col {
    min-width: 180px;
  }
  .product-code-col {
    min-width: 180px;
  }
  .status-col {
    min-width: 90px;
    white-space: nowrap;
  }
  .time-col {
    min-width: 160px;
    white-space: nowrap;
  }
  .action-col {
    min-width: 120px;
    white-space: nowrap;
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
}

@media screen and (max-width: 768px) {
  .product-list {
    .content-header {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding-left: 10px;
      padding-right: 10px;
    }
    .m-input-outer {
      width: 100%;
    }
    .product-code-input,
    .status-input {
      width: 100%!important;
      margin-left: 0;
      margin-right: 0;
    }
    .box-item {
      margin-left: 0;
      margin-right: 8px;
      margin-bottom: 10px;
    }
    .search-btn,
    .add-btn,
    .mutil-btn {
      min-width: 96px;
    }
    .pagination-outer {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      overflow: hidden;
      padding-left: 20px;
      padding-right: 20px;
    }
    .paginnation-left {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
    }
    .pagination-box {
      width: 100%!important;
      justify-content: flex-start!important;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
    }
    /deep/ .vs-pagination--nav {
      width: max-content;
      min-width: 100%;
    }
    /deep/ .vs-pagination--buttons {
      width: 32px;
      min-width: 32px;
      height: 32px;
      margin-left: 2px;
      margin-right: 2px;
    }
    /deep/ .vs-pagination--li {
      width: 28px;
      min-width: 28px;
      height: 28px;
      margin-left: 1px;
      margin-right: 1px;
    }
  }
}
</style>
